import { useNavigate } from "@tanstack/react-router";
import Chip from "@mui/material/Chip";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

import { currencyFormatter } from "../utils/Utils";
import { DataTable } from "./DataTable";

const money = (field) => ({
  id: field,
  accessorFn: (row) => currencyFormatter(row.currencyCode, row[field]),
  meta: { minWidth: 150 },
});

const sharedColumns = [
  { accessorKey: "no", header: "No.", meta: { minWidth: 200 } },
  {
    accessorKey: "postingDate",
    header: "Invoice Date",
    meta: { minWidth: 150 },
  },
  { accessorKey: "orderNo", header: "Order", meta: { minWidth: 150 } },
  {
    accessorKey: "yourReference",
    header: "Reference",
    meta: { minWidth: 150 },
  },
  { accessorKey: "dueDate", header: "Due Date", meta: { minWidth: 150 } },
];

const amountColumns = [
  { ...money("remainingAmount"), header: "Outstanding" },
  { ...money("amount"), header: "Total" },
];

const dueDateStatusColumn = {
  accessorKey: "dueDateOverdue",
  header: "Status",
  meta: { minWidth: 150 },
  cell: (info) => {
    const invDate = dayjs(info.row.original.dueDate, "DD/MM/YY");
    const daysOutstanding = dayjs().diff(invDate, "day");
    const overdue = info.getValue() === "true";
    const days = Math.abs(daysOutstanding);

    return (
      <Chip
        variant="outlined"
        color={overdue ? "error" : "info"}
        clickable={false}
        label={
          overdue
            ? `${daysOutstanding} ${daysOutstanding > 1 ? "days" : "day"} overdue`
            : `Due in ${days} ${days > 1 ? "days" : "day"}`
        }
      />
    );
  },
};

const columns = {
  outstanding: [...sharedColumns, dueDateStatusColumn, ...amountColumns],
  settled: [...sharedColumns, ...amountColumns],
};

export const InvoiceTable = ({
  data,
  loading,
  invoiceFilter,
  setInvoiceFilter,
  type,
}) => {
  const navigate = useNavigate();

  const invoices = data?.invoice || [];
  const rowCount = Number(data?.paging?.noOfRecords) || 0;

  const pagination = {
    page: (invoiceFilter?.page ?? 1) - 1,
    pageSize: invoiceFilter?.pageSize ?? 25,
  };

  const handlePaginationChange = (next) => {
    setInvoiceFilter((prevState) => ({
      ...prevState,
      page: next.page + 1,
      pageSize: next.pageSize,
    }));
  };

  return (
    <DataTable
      aria-label="Invoices"
      columns={columns[type]}
      rows={invoices}
      getRowId={(row) => row.no}
      rowCount={rowCount}
      page={pagination.page}
      pageSize={pagination.pageSize}
      loading={loading}
      onPaginationChange={handlePaginationChange}
      onRowClick={(row) => navigate({ to: `/invoices/${row.no}` })}
    />
  );
};

// {
//   "no": "SI244922",
//   "postingDate": "14/08/23",
//   "dueDate": "13/09/23",
//   "amount": "47.73",
//   "currencyCode": null,
//   "documentDate": "14/08/23",
//   "dueDateOverdue": "true",
//   "origamount": "47.73",
//   "remainingAmount": "47.73",
//   "postingDateXML": "2023-08-14"
// }

// {
//   "no": "SI244906",
//   "postingDate": "16/05/23",
//   "dueDate": "15/06/23",
//   "amount": "33.24",
//   "currencyCode": null,
//   "documentDate": "16/05/23",
//   "dueDateOverdue": "true",
//   "origamount": "33.24",
//   "remainingAmount": "33.24",
//   "postingDateXML": "2023-05-16"
// }
